import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';

const UserAgreement: React.FC = () => {
  return (
    <LegalPageLayout title="User Agreement" lastUpdated="August 13, 2026">
      <p>
        This User Agreement (“Agreement”) governs your access to and use of the
        Where To Invest (“WTI”, “we”, “us”, or “our”) website, application, and
        related services (collectively, the “Service”). By creating an account,
        purchasing a subscription, or using the Service, you agree to this
        Agreement.
      </p>

      <h2>1. Eligibility</h2>
      <p>
        You must be at least 18 years old and able to form a binding contract to
        use the Service. By using the Service, you represent that the information
        you provide is accurate and that you will keep your account credentials
        secure.
      </p>

      <h2>2. The Service</h2>
      <p>
        WTI provides real-estate research tools, address evaluation reports,
        neighborhood insights, training resources, and related features. The
        Service is informational and educational. It is not investment, legal,
        tax, or financial advice, and it does not guarantee investment returns
        or property performance.
      </p>

      <h2>3. Accounts and Access</h2>
      <ul>
        <li>
          Access is generally provided after purchase through our checkout flow
          or by authorized account provisioning.
        </li>
        <li>
          You may sign in with a password or a secure one-time magic link sent to
          your email address.
        </li>
        <li>
          You are responsible for all activity under your account. Notify us
          promptly if you suspect unauthorized use.
        </li>
        <li>
          We may suspend or terminate access if we reasonably believe your
          account is being misused, shared improperly, or used in violation of
          this Agreement.
        </li>
      </ul>

      <h2>4. Subscriptions, Billing, and Cancellation</h2>
      <ul>
        <li>
          Paid plans, prices, and billing intervals are presented at checkout
          (including promotional pricing, when offered).
        </li>
        <li>
          Payments are processed by our payment / CRM partners. Their terms may
          also apply to billing.
        </li>
        <li>
          Plan limits (such as reports, saved reports, and history access) apply
          according to your active package.
        </li>
        <li>
          If you cancel a subscription, access generally continues through the
          end of the current paid billing period, after which paid features may
          pause.
        </li>
        <li>
          Refunds, if any, are handled according to the refund policy stated at
          purchase or by applicable law.
        </li>
      </ul>

      <h2>5. Acceptable Use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Share, resell, or publicly redistribute paid reports without permission</li>
        <li>Attempt to reverse engineer, scrape, or overload the Service</li>
        <li>Circumvent usage limits, authentication, or security controls</li>
        <li>Use the Service for unlawful, deceptive, or abusive purposes</li>
        <li>Upload malicious code or interfere with other users’ access</li>
      </ul>

      <h2>6. Intellectual Property</h2>
      <p>
        The Service, including software, branding, layouts, training content, and
        report formats, is owned by WTI or its licensors. You receive a limited,
        non-exclusive, non-transferable license to use the Service for your own
        internal business or personal investment research while your account is
        authorized.
      </p>

      <h2>7. Third-Party Data and Links</h2>
      <p>
        The Service may include or rely on third-party data sources, maps,
        community platforms, or payment providers. We do not control those
        services and are not responsible for their availability, accuracy, or
        policies.
      </p>

      <h2>8. Disclaimers</h2>
      <p>
        THE SERVICE IS PROVIDED “AS IS” AND “AS AVAILABLE.” TO THE MAXIMUM
        EXTENT PERMITTED BY LAW, WE DISCLAIM WARRANTIES OF MERCHANTABILITY,
        FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. Market data,
        estimates, scores, and forecasts may be incomplete, delayed, or
        incorrect.
      </p>

      <h2>9. Limitation of Liability</h2>
      <p>
        TO THE MAXIMUM EXTENT PERMITTED BY LAW, WTI AND ITS AFFILIATES WILL NOT
        BE LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE
        DAMAGES, OR FOR LOST PROFITS, LOST DATA, OR INVESTMENT LOSSES ARISING
        FROM YOUR USE OF THE SERVICE. OUR TOTAL LIABILITY FOR ANY CLAIM RELATING
        TO THE SERVICE IS LIMITED TO THE AMOUNTS YOU PAID TO US FOR THE SERVICE
        IN THE TWELVE (12) MONTHS BEFORE THE CLAIM.
      </p>

      <h2>10. Indemnification</h2>
      <p>
        You agree to indemnify and hold harmless WTI from claims arising out of
        your misuse of the Service, your violation of this Agreement, or your
        violation of applicable law.
      </p>

      <h2>11. Changes</h2>
      <p>
        We may update this Agreement from time to time. The “Last updated” date
        will change when we do. Continued use of the Service after changes means
        you accept the updated Agreement.
      </p>

      <h2>12. Contact</h2>
      <p>
        Questions about this Agreement: {' '}
        <a href="mailto:support@wheretoinvest.io">support@wheretoinvest.io</a>
        {' '}or visit{' '}
        <a href="https://wheretoinvest.io" target="_blank" rel="noopener noreferrer">
          wheretoinvest.io
        </a>.
      </p>
    </LegalPageLayout>
  );
};

export default UserAgreement;
